import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AICreationWorkspace } from "@core/components/ai/AICreationWorkspace";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";

export default function FormPollCreationWorkspace() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("type") !== "form") {
      searchParams.set("type", "form");
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className="flex flex-col h-screen bg-background dark:bg-[#0a0a0a] overflow-hidden">
      <div className="fixed top-0 left-0 right-0 z-50 w-full">
        <ProductHeader
          productType="form"
          showAuth={true}
          showAuthButtons={true}
        />
      </div>

      <div className="flex flex-1 overflow-hidden">
        <ProductSidebar productType="form" />
        <AICreationWorkspace
          pollTypeFromUrl="form"
          hideSidebar={true}
          externalHeaderHeight={64}
        />
      </div>
    </div>
  );
}
